module.exports = __webpack_public_path__ + "static/media/sidharth_yadav.4a77a489.jpeg";